"use client";

import { useId, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { webSiteNavigationLabels } from "../webSiteNavigation";
import { useCinematicWebRuntime } from "./useCinematicWebRuntime";
import { useWebMobileMenuOverlay } from "./useWebMobileMenuOverlay";

export function BoutiqueMobileMenu({
    languageCode,
}: {
    languageCode?: string | null;
}) {
    const navigationId = useId();
    const sentinelRef = useRef<HTMLSpanElement>(null);
    const toggleRef = useRef<HTMLButtonElement>(null);
    const [isOpen, setIsOpen] = useState(false);
    const labels = webSiteNavigationLabels(languageCode);
    const header = useCinematicWebRuntime({
        headerScrolledAttribute: "data-boutique-header-scrolled",
        revealedAttribute: "data-boutique-revealed",
        revealAttribute: "data-boutique-reveal",
        runtimeReadyAttribute: "data-boutique-runtime-ready",
        sentinelRef,
        templateCode: "boutique-service",
    });

    useWebMobileMenuOverlay({
        header,
        isOpen,
        navigationId,
        openAttribute: "data-boutique-mobile-menu-open",
        setIsOpen,
        templateCode: "boutique-service",
        toggleRef,
    });

    return (
        <>
            <span
                aria-hidden="true"
                data-boutique-mobile-menu-runtime="true"
                ref={sentinelRef}
                style={{ display: "none" }}
            />
            {header
                ? createPortal(
                    <button
                        aria-controls={navigationId}
                        aria-expanded={isOpen}
                        aria-label={isOpen ? labels.closeMenu : labels.openMenu}
                        className="boutique-mobile-menu-toggle"
                        onClick={(event) => {
                            event.stopPropagation();
                            setIsOpen((current) => !current);
                        }}
                        onPointerDown={(event) => event.stopPropagation()}
                        ref={toggleRef}
                        type="button"
                    >
                        <span aria-hidden="true" />
                        <span aria-hidden="true" />
                        <span aria-hidden="true" />
                    </button>,
                    header,
                )
                : null}
        </>
    );
}
